import { render, staticRenderFns } from "./CommissionsPending.vue?vue&type=template&id=1752223d"
import script from "./CommissionsPending.vue?vue&type=script&lang=js"
export * from "./CommissionsPending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports